<template>
  <div
    class="phase-bar"
    :class="phaseBarClass"
  >
    <div
      v-for="(phase, key, index) in visiblePhases"
      :key="key"
      class="phase"
      :class="
        currentPhaseIndex >= index
          ? currentPhaseIndex === index
            ? 'active'
            : 'done'
          : ''
      "
      @click="
        currentPhaseIndex >= index
          ? progress === 100
            ? null
            : $router.push({ name: key })
          : null
      "
    >
      <span class="phase-number index"> {{ ++index }} </span>
      <span class="label"> {{ phase.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Phasebar',
    data() {
        return {
            phases: {
                wizard: {
                    title: 'Jouw situatie',
                    pageTitle: 'Start met vergelijken | Keuze.nl',
                    secure: false,
                    visible: true,
                    showBackButton: true,
                },
                compare: {
                    title: 'Energie vergelijken',
                    pageTitle: 'Energie vergelijken | Keuze.nl',
                    secure: false,
                    visible: true,
                    showBackButton: true,
                },
                form: {
                    title: 'Aanmelden',
                    pageTitle: 'Vul je gegevens in en stap over | Keuze.nl',
                    secure: true,
                    visible: true,
                    showBackButton: true,
                },
                productLink: {
                    title: 'We sturen je door naar de leverancier',
                    pageTitle: 'Gelukt! | Keuze.nl',
                    secure: true,
                    visible: false,
                    showBackButton: false,
                },
                confirmation: {
                    title: 'Het is gelukt',
                    pageTitle: 'Gelukt! | Keuze.nl',
                    secure: false,
                    visible: false,
                    showBackButton: false,
                    showConfirmation: true,
                },
            },
        };
    },
    computed: {
        currentPhase() {
            return (
                this.phases[
                    Object.keys(this.phases).find((key) => key === this.$route.name)
                ] || this.phases.wizard
            );
        },
        currentPhaseIndex() {
            return Object.keys(this.phases).findIndex((phase) => phase === this.$route.name);
        },
        visiblePhases() {
            return Object.fromEntries(
                Object.entries(this.phases).filter(([, phase]) => phase.visible),
            );
        },
        progress() {
            return (
                (100 / ++Object.keys(this.visiblePhases).length)
        * (this.currentPhaseIndex + 1)
            );
        },
        phaseBarClass() {
            return this.progress >= 100 ? 'done' : 'active';
        },
    },
    watch: {
        $route: {
            handler() {
                this.updatePageTitle(this.currentPhase.pageTitle);
                this.$emit('updateProgress', this.progress);
                this.$emit('updateCurrentPhase', this.currentPhase);
            },
            immediate: true,
        },
    },
    methods: {
        updatePageTitle(pageTitle) {
            document.title = pageTitle;
        },
    },
};
</script>

<style lang="scss" scoped>
@use "assets/scss/_helpers/display";
@use "assets/scss/_helpers/border";
@use "assets/scss/_helpers/breakpoint";
@use "assets/scss/_helpers/input";
@use 'assets/scss/_variables/colors';
@use "assets/scss/_helpers/typography";

.phase-bar {
  @include display.flex-row-end;

  //Disable clicks on outclick/confirmation view
  &.done {
    pointer-events: none;
  }
  .phase-number {
    @include display.flex-col-center;
    @include typography.content-short-strong;
    
    border: 2px solid colors.$border-base;
    position: relative;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    margin-right: 8px;

    transition: color 0.2s ease;

    &::after {
      transition: background-color 0.2s ease;
      margin: 3px !important;
    }
  }

  .label {
    @include typography.link-default();

    display: none;
    transition: color 0.2s ease;

    @include breakpoint.up(xl) {
      display: inherit;
    }
  }

  .phase {
    @include display.flex-row-start;

    margin-right: 8px;
    color: colors.$text-inactive;

    @include breakpoint.up(md) {
      margin-right: 16px;
    }

    @include breakpoint.up(lg) {
      margin-right: 32px;
    }

    &.done {
      .label {
        color: colors.$link-base-default;
      }

      .phase-number {
        @include input.checkmark-svg(
          $check-color: colors.$link-base-default,
          $background: colors.$grey-10
        );

        color: transparent;
      }

      &:hover {
        cursor: pointer;

        .phase-number {
          &::after {
            background-color: colors.$link-base-hover;
          }
        }
        .label {
          color: colors.$link-base-hover;
        }
      }
    }

    &.active {
      .label {
        font-weight: 500;
        color: black;
      }

      .phase-number {
        border: 2px solid colors.$link-base-active;
        color: colors.$link-base-active;
        background: colors.$background-default;
      }
    }
  }
}
</style>
